import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const api = "https://apideneme.com.tr/api"; // API adresini belirtin

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      // Kayıt işlemi için API'ye istek gönder
      await axios.post(`${api}/users`, { name, email, password });
      alert("Kayır Başarıyla Tamamlandı!");

      // Kayıt işlemi başarılı olduğunda ana sayfaya yönlendir
      navigate('/'); // Ana sayfaya yönlendir
    } catch (error) {
      console.error("Kayıt sırasında hata oluştu:", error);
      setError(error.response?.data?.message || 'Kayıt başarısız. Lütfen bilgilerinizi kontrol edin.');
    }
  };

  return (
    <div className="login-container">
      <h2>Register</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleRegister} className="login-form">
        <div className="input-group">
          <span className="icon" role="img" aria-label="user icon">&#128100;</span>
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <span className="icon" role="img" aria-label="email icon" style={{ color: "black" }}>&#9993;</span>
          <input
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <span className="icon" role="img" aria-label="lock icon" style={{ color: "black" }}>&#128274;</span>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button 
          type="submit" 
          style={{ padding: '10px', backgroundColor: '#333', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
        >
          Register
        </button>
      </form>
    </div>
  );
};

export default Register;
